import React from 'react';
import { motion } from 'framer-motion';
import { BedDoubleIcon, MapPinIcon, ClockIcon, ShirtIcon } from 'lucide-react';
import { party, essentials } from '../data/party';
type InfoCard = {
  icon: typeof MapPinIcon;
  title: string;
  lines: string[];
  link?: {
    href: string;
    label: string;
  };
};
const cards: InfoCard[] = [{
  icon: MapPinIcon,
  title: 'Where',
  lines: [party.venueName, party.venueAddress],
  link: {
    href: party.estateMapUrl,
    label: 'View the estate map'
  }
}, {
  icon: ClockIcon,
  title: 'When',
  lines: [`${party.dateLong}, ${party.year}`, party.gates]
}, {
  icon: BedDoubleIcon,
  title: 'Stay',
  lines: [party.accommodations]
}, {
  icon: ShirtIcon,
  title: 'Dress Code',
  lines: [party.dressCode]
}];
export function Info() {
  return <section id="info" className="w-full bg-[var(--sand)] px-5 py-24" data-id="element-32" data-mp="2alb5lssze2lp">
      <div className="mx-auto max-w-5xl" data-id="element-33" data-mp="25tax3byui1di">
        <h2 className="font-display mb-14 text-center text-5xl uppercase text-[var(--terracotta)] sm:text-7xl" data-id="element-34" data-mp="25shzp1ls0o81">
          The Essentials
        </h2>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-35" data-mp="3psjdcn25m8k5">
          {cards.map((card, i) => <motion.div key={card.title} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.45,
          delay: i * 0.1
        }} className="rounded-3xl border border-[var(--terracotta)]/10 bg-[var(--cream)] p-8 shadow-sm" data-id="element-36" data-mp="3c14qg554ln7t" data-mpi={i}>
              <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-full bg-[var(--sunset)] text-white" data-id="element-37" data-mp="2t1qw3m3hiags">
                <card.icon className="h-6 w-6" data-id="element-38" data-mp="2y0byns67l68e" />
              </div>
              <h3 className="font-poster mb-3 text-2xl uppercase tracking-wide text-[var(--night)]" data-id="element-39" data-mp="2y2okigf380qq">
                {card.title}
              </h3>
              {card.lines.map(line => <p key={line} className="leading-relaxed text-[var(--dusk)]" data-id="element-40" data-mp="w74jciqliomi">
                  {line}
                </p>)}
              {card.link ? <a href={card.link.href} target="_blank" rel="noreferrer" className="mt-3 inline-block font-semibold text-[var(--terracotta)] underline underline-offset-4 transition-colors hover:text-[var(--sunset)]" data-id="element-41" data-mp="prnjxz2x6z7d">
                  {card.link.label}
                </a> : null}
            </motion.div>)}
        </div>

        <div className="mt-14 flex flex-wrap justify-center gap-4" data-id="element-42" data-mp="18m2lnwgm95yw">
          {essentials.map((e, i) => <motion.div key={e.label} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.35,
          delay: i * 0.08
        }} className="flex items-center gap-3 rounded-full bg-white px-5 py-3 shadow-sm" data-id="element-43" data-mp="ytww0tdu70mv" data-mpi={i}>
              <span className="text-2xl" aria-hidden="true" data-id="element-44" data-mp="1yvjqdlmkyqtl">{e.emoji}</span>
              <span className="font-bold text-[var(--night)]" data-id="element-45" data-mp="23tl925g3go4j">{e.label}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}